import { Bar } from "react-chartjs-2";

function BarChartStacked({ data: dataParam = [], showTicksX }) {
  const options = {
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        labels: {
          title: null,
        },
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
        ticks: {
          display: showTicksX,
        },
      },
      y: {
        stacked: true,
      },
    },
  };

  const data = {
    labels: dataParam.columns,
    datasets: dataParam.types,
  };
  return <Bar data={data} options={options} />;
}

export default BarChartStacked;
